import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../axios";
import { useThemePreview } from "../themePreview";
import { PhotoCarousel, eventSlides, money, showDate, todayKey } from "../components/ShowPieces";

function ShowLink({ item, fee }) {
  return (
    <Link className="day-row" to={`/show/${item.id}`}>
      <span>{showDate(item.date)}</span>
      <strong>
        {item.title}
        {fee && Number(item.entry_fee) ? ` · ${money(item.entry_fee)}` : ""}
      </strong>
      <span className="day-view">View</span>
    </Link>
  );
}

function ShowScreen() {
  const { images } = useThemePreview();
  const [events, setEvents] = useState([]);
  const [winners, setWinners] = useState([]);
  const [gallery, setGallery] = useState(null);

  useEffect(() => {
    axios
      .get("/api/users/events/")
      .then(({ data }) => setEvents(data))
      .catch(() => setEvents([]));
    axios
      .get("/api/users/results/")
      .then(({ data }) => setWinners(data))
      .catch(() => setWinners([]));
    axios
      .get("/api/users/show-photos/")
      .then(({ data }) => setGallery(data))
      .catch(() => setGallery([]));
  }, []);

  const today = todayKey();
  const upcoming = events.filter((item) => item.date >= today);
  const past = [...events].reverse().filter((item) => item.date < today);
  const slides = [
    ...events.flatMap((event) => eventSlides(event)),
    ...winners.filter((item) => item.image).map((item) => ({ src: item.image, caption: item.vehicle_name })),
  ];
  const curated = (gallery || []).map((photo) => ({
    src: photo.display_url,
    caption: photo.caption,
  }));
  const heroSlides = curated.length
    ? curated
    : slides.length
      ? slides
      : [{ src: images.hero, caption: "Huntington Beach Concours" }];

  return (
    <div className="beach">
      {gallery === null ? (
        <section className="photo-hero" aria-label="Event photos" />
      ) : (
        <PhotoCarousel slides={heroSlides} />
      )}
      <section className="site-section">
        <div className="site-wrap">
          <p className="site-kicker">The show</p>
          <h1>On the lawn</h1>
          <p>Upcoming shows are listed first. Open one to see its photos, classes, and luncheon.</p>
          <p className="show-ticket-link">
            <Link className="btn btn-site" to="/tickets">
              Spectator tickets
            </Link>
          </p>
          {upcoming.length === 0 ? (
            <p className="quiet">The next show will appear here.</p>
          ) : (
            <div className="day-list">
              {upcoming.map((item) => (
                <ShowLink key={item.id} item={item} fee />
              ))}
            </div>
          )}
          {past.length > 0 && (
            <>
              <h2 className="past-heading">Past events</h2>
              <div className="day-list">
                {past.map((item) => (
                  <ShowLink key={item.id} item={item} />
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}

export default ShowScreen;
